module.exports = __webpack_public_path__ + "img/bottomLogo.cf99dec6.png";